export default __webpack_public_path__ + "static/studio-slider-13-2b5071f099a8a40d064d3cc4cd5262fa.png";